// extracted by mini-css-extract-plugin
export default {"container":"theme_container__rgorS","legendName":"theme_legendName__Lu86B","smallContainer":"theme_smallContainer__HIhKW"};